import React from 'react';
import { Icon } from './Icon.js';
export const IconMouse2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9.75,1h-1.5C5.631,1,3.5,3.131,3.5,5.75v6.5c0,2.619,2.131,4.75,4.75,4.75h1.5c2.619,0,4.75-2.131,4.75-4.75V5.75c0-2.619-2.131-4.75-4.75-4.75Zm0,6.75c0,.414-.336,.75-.75,.75s-.75-.336-.75-.75v-2.5c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v2.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMouse2Fill18.js.map